import { mobileApiRequest, uiInformationRequest } from '../../apiRequests'

export const listProcesses = async () => {
    const action = {
        action: 'listProcesses',
    }
    return await mobileApiRequest(action)
}

export const getReportSeriesData = async () => {
    const action = {
        action: 'getReportSeriesMetadata',
        includeColumnMetadata: false,
    }
    return await mobileApiRequest(action)
}

export const uiDiagramRequest = async (data) => {
    return await uiInformationRequest(data.payload)
}

// ----

export const saveProcessDiagramPreferences = async (data) => {
    const payload = {
        action: 'saveProcessDiagramPreferences',
        diagramName: data.diagramName,
        json: data.json,
    }

    return await uiInformationRequest(payload)
}

export const deleteProcessDiagramPreferences = async (data) => {
    const payload = {
        action: 'deleteProcessDiagramPreferences',
        diagramName: data.diagramName,
    }

    return await uiInformationRequest(payload)
}

export const getProcessDiagramPreferences = async (diagramName) => {
    const payload = {
        action: 'getProcessDiagramPreferences',
        diagramName,
    }

    return await uiInformationRequest(payload)
}

export const listProcessDiagramPreferences = async () => {
    const payload = {
        action: 'listProcessDiagramPreferences',
    }
    return await uiInformationRequest(payload)
}

export const getSankey = async (data) => {
    const action = {
        action: 'getSankey',
        ...data,
    }

    return await mobileApiRequest(action)
}

export const getProcessInsightDiagram = async (data) => {
    const payload = {
        action: 'getProcessInsightDiagram',
        ...data,
    }

    return await mobileApiRequest(payload)
}
